import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFetchPdfDoc } from "../../hooks/useFetchPdfDoc";
import { PdfViwer, ButtonGroup } from "./index";

const QuoteApprovalDetails = (props) => {
  const { t } = useTranslation();
  const {
    user,
    settingsConfig,
    spinnerCtx,
    quoteRecord,
    quoteId,
    isCoveringManager,
    handleCancel,
    rejectHandler,
    setRejectHandler,
    approveOnClick,
  } = props;

  const [pdfHandler, setPdfHandler] = useState({
    pdfbinary: null,
    actionAllowed: false,
    quoteDetails: null,
  });

  const documetResponse = useFetchPdfDoc(
    settingsConfig.businessCode,
    settingsConfig.countryCode,
    quoteId,
    quoteRecord,
    isCoveringManager === true ? true : false,
    user.userRecord.email
  );

  const btnStyle = {
    disabled: false,
    width: "100px",
    margin: "5px 30px",
    buttonColor: "grey",
    buttonText: t("generic.reject"),
    boxShadow: "#00000033 0px 3px 1px -2px, #00000024 0px 2px 2px 0px, #0000001f 0px 1px 5px 0px ",
    borderRadius: "5px",
  };

  const handleReject = () => {
    try {
      if (!rejectHandler.rejectionReason && !rejectHandler.isReject) {
        setRejectHandler((prevState) => ({
          ...prevState,
          isReject: true,
          rejectedQuoteRecord: pdfHandler.quoteDetails,
        }));
      }
    } catch (error) {
      alert(error);
    }
  };

  const handleApprove = async (event) => {
    try {
      await approveOnClick(pdfHandler.quoteDetails);
      handleCancel(event);
    } catch (error) {
      alert(error);
    }
  };

  useEffect(() => {
    spinnerCtx.setLoadingIndicator(true);
    if (documetResponse && documetResponse.apiFetchComplete && documetResponse.apiFetchComplete === true) {
      setPdfHandler((prevState) => ({
        ...prevState,
        pdfbinary: documetResponse?.pdfbinary,
        actionAllowed: documetResponse?.actionAllowed,
        quoteDetails: documetResponse?.quoteDetails,
      }));
      spinnerCtx.setLoadingIndicator(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documetResponse]);

  return (
    <div
      style={{
        paddingTop: "10px",
        paddingLeft: "53px",
        height: "calc(100vh - 48px - 64px - 10px)",
        width: "calc(100vw - 53px)",
      }}
    >
      {pdfHandler.pdfbinary && (
        <>
          <PdfViwer pdfSrc={pdfHandler.pdfbinary} height="calc(100vh - 48px - 64px - 55px - 20px)" />
          <ButtonGroup
            justifyContent="center"
            buttons={
              pdfHandler.actionAllowed
                ? [
                    {
                      ...btnStyle,
                      buttonText: t("generic.approve"),
                      buttonColor: "#354A55",
                      textColor: "#fff",
                      buttonType: "filled",
                      onClick: handleApprove,
                    },
                    {
                      ...btnStyle,
                      buttonText: t("generic.reject"),
                      onClick: handleReject,
                    },
                    {
                      ...btnStyle,
                      buttonColor: "transparent",
                      buttonText: t("generic.cancel"),
                      onClick: handleCancel,
                    },
                  ]
                : [
                    {
                      ...btnStyle,
                      buttonColor: "transparent",
                      buttonText: t("generic.cancel"),
                      onClick: handleCancel,
                    },
                  ]
            }
          />
        </>
      )}
    </div>
  );
};

export default QuoteApprovalDetails;
